import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_HLWN_70: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_PAGE_HLWN_70,
  },
  {
    pageId: PageId.CHAT_UPSELL_HLWN_70,
  },
  {
    pageId: PageId.UPSELL_HLWN_70,
  },
  {
    pageId: PageId.DOWNLOAD_HLWN_70,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
